(function (module) {
    'use strict';

    function ViewProfileCtrl($timeout, $scope, $state, User, Store) {

        this.$onInit = () => {
            this.current = Store.getCurrentUser();
        };

        this.save = () => {
            // IMPORTANT, this is how we use those methods: https://github.com/strongloop/loopback-sdk-angular/issues/111
            User.prototype$patchAttributes(this.current)
                .$promise
                .then((user) => {
                    this.users = Store.setSingleModelData('users', user.id, user);
                    Store.setCurrentUser(user);
                    this.form.$setPristine();
                })
                .catch((error) => {
                    console.error(error);
                    Raven.captureException(error);
                });

        };

    }

    module
        .config(function ($stateProvider) {
            $stateProvider
                .state('root.my-profile.view', {
                    url: '/my-profile/view',
                    data: {
                        pageTitle: 'MY_PROFILE_VIEW.PAGE_TITLE',
                    },
                    views: {
                        'content@root': {
                            template: '<my-profile-view-component />',
                        },
                    },
                });
        })

        .component('myProfileViewComponent', {
            templateUrl: '/js/my-profile/view-profile/view-profile.html',
            controller: ViewProfileCtrl,
        });

})(angular.module('rocket.components'));
